var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// /Users/kristinberlehner/sites/recipe-search/wp-content/themes/nutrition-for-me/node_modules/lodash/_Symbol.js
// module id = 6
// module chunks = 0 1